import { useEffect, useState } from "react";
import { Download, Share, PlusSquare, X } from "lucide-react";
import { canInstall, onInstallChange, promptInstall, isIos, isStandalone } from "../../lib/push";

const L = {
  en: { install: "Install app", installed: "Installed", iosTitle: "Add BUMA to your Home Screen", ios1: "Tap the Share button", ios2: "Choose “Add to Home Screen”", close: "Close", hint: "Open it from your home screen like any app — faster, full screen, with notifications." },
  ar: { install: "تثبيت التطبيق", installed: "مثبّت", iosTitle: "أضف BUMA إلى الشاشة الرئيسية", ios1: "اضغط زر المشاركة", ios2: "اختر «إضافة إلى الشاشة الرئيسية»", close: "إغلاق", hint: "افتحه من شاشتك الرئيسية كأي تطبيق — أسرع، بملء الشاشة، ومع الإشعارات." },
};

// "Install app" — native prompt where available, Share → Add to Home Screen walkthrough on iOS; hidden once installed.
export function InstallButton({ lang = "en", className = "", compact = false }) {
  const t = L[lang] || L.en;
  const [can, setCan] = useState(canInstall());
  const [ios, setIos] = useState(false);
  useEffect(() => onInstallChange(setCan), []);
  if (isStandalone()) return null;
  const showIos = isIos() && !can;
  if (!can && !showIos) return null;
  const click = async () => { if (can) { await promptInstall(); } else setIos(true); };
  return <>
    <button type="button" data-testid="pwa-install-btn" onClick={click} className={className || "inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-[#0038EB] text-white text-xs font-bold hover:bg-[#002FC4]"}><Download size={14} /> {!compact && t.install}</button>
    {ios && <div className="fixed inset-0 z-[70] grid place-items-end sm:place-items-center bg-slate-900/50 p-3" onClick={() => setIos(false)} data-testid="pwa-ios-hint">
      <div className="w-full max-w-sm rounded-3xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3"><h3 className="font-bold text-slate-900">{t.iosTitle}</h3><button type="button" onClick={() => setIos(false)} className="p-1 text-slate-400"><X size={16} /></button></div>
        <p className="mt-1 text-xs text-slate-500">{t.hint}</p>
        <ol className="mt-3 space-y-2 text-sm text-slate-700">
          <li className="flex items-center gap-2"><span className="grid place-items-center w-7 h-7 rounded-lg bg-blue-50 text-[#0038EB]"><Share size={15} /></span> {t.ios1}</li>
          <li className="flex items-center gap-2"><span className="grid place-items-center w-7 h-7 rounded-lg bg-blue-50 text-[#0038EB]"><PlusSquare size={15} /></span> {t.ios2}</li>
        </ol>
      </div>
    </div>}
  </>;
}
